import { useContext } from 'react';
import { ResourceManagementContext } from './ResourceManagementContext';

export default () => {
  const { searchCriteria, setSearchCriteria } = useContext(
    ResourceManagementContext
  );

  return { searchCriteria, setSearchCriteria };
};
